import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Col, Card, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  MARAPHONS_SUCCESS,
  MARAPHONS_FAILED,
  maraphonClearState as maraphonClearStateAction,
  getAsyncData as getAsyncDataAction,
  getMaraphon as getMaraphonAction,
} from '../../../../redux/actions/maraphonsAction';
import WizardFormOne from './WizardFormOne';
import WizardFormTwo from './WizardFormTwo';
import WizardFormThree from './WizardFormThree';
import WizardFormFour from './WizardFormFour';
import { FullWideNotification } from '../../../../shared/components/Notification';

class WizardForm extends PureComponent {
  static propTypes = {
    initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncStatus: PropTypes.string.isRequired,
    submitStatus: PropTypes.string.isRequired,
    loadStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    getAsyncData: PropTypes.func.isRequired,
    maraphonClearState: PropTypes.func.isRequired,
    getMaraphon: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const {
      // eslint-disable-next-line react/prop-types
      getAsyncData,
      getMaraphon,
      // eslint-disable-next-line react/prop-types
      match,
      // eslint-disable-next-line react/prop-types
      reinitializeReduxForm,
    } = this.props;
    // eslint-disable-next-line react/prop-types
    const { maraphonId } = match.params;

    reinitializeReduxForm();

    getAsyncData();
    getMaraphon(maraphonId);
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, loadStatus, history } = nextProps;

    if (loadStatus === MARAPHONS_FAILED) {
      history.push('/404');
    }

    if (submitStatus === MARAPHONS_SUCCESS) {
      history.push('/maraphons');
    } else if (submitStatus === MARAPHONS_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { maraphonClearState } = this.props;
    maraphonClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  nextPage = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  };

  render() {
    const { asyncData, asyncStatus, loadStatus, showNotification, initialValues } = this.props;
    const { page } = this.state;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 1</p>
                </div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 2</p>
                </div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 3</p>
                </div>
                <div className={`wizard__step${page === 4 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 4</p>
                </div>
              </div>
              {asyncStatus === MARAPHONS_SUCCESS && loadStatus === MARAPHONS_SUCCESS && (
                <div className="wizard__form-wrapper">
                  {page === 1 && (
                    <WizardFormOne onSubmit={this.nextPage} asyncData={asyncData} initialValues={initialValues} />
                  )}
                  {page === 2 && (
                    <WizardFormTwo previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 3 && (
                    <WizardFormThree
                      previousPage={this.previousPage}
                      onSubmit={this.nextPage}
                      showNotification={showNotification}
                    />
                  )}
                  {page === 4 && <WizardFormFour previousPage={this.previousPage} />}
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  initialValues: state.maraphons.active,
  asyncData: state.maraphons.asyncData,
  asyncStatus: state.maraphons.asyncStatus,
  submitStatus: state.maraphons.submitStatus,
  loadStatus: state.maraphons.loadActiveStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getMaraphon: (maraphonId) => dispatch(getMaraphonAction(maraphonId)),
  getAsyncData: () => dispatch(getAsyncDataAction()),
  maraphonClearState: () => dispatch(maraphonClearStateAction()),
  reinitializeReduxForm: () => dispatch(destroy('maraphons_edit_form')),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(WizardForm)));
